import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LanguageSelectorModel } from '../model/language-selector.model';
import { LANGUAGES } from '../language-selector-data';


@Injectable({
  providedIn: 'root'
})
export class LanguageSelectorService {
  private defaultLang: LanguageSelectorModel = {
    code: 'en',
    name: 'English',
    flag: 'https://flagcdn.com/w20/us.png'
  };

  private languageSubject = new BehaviorSubject<LanguageSelectorModel>(this.defaultLang);
  language$ = this.languageSubject.asObservable();

  setLanguage(lang: LanguageSelectorModel): void {
    this.languageSubject.next(lang);
    this.updateDocumentLang(lang.code);
  }

  getCurrentLanguage(): LanguageSelectorModel {
    return this.languageSubject.value;
  }

  getAvailableLanguages(): LanguageSelectorModel[] {
    return LANGUAGES;
  }

  changeLanguage(language: string): void {
    const selectedLanguage = LANGUAGES.find(lang => lang.code === language);
    if (selectedLanguage) {
      this.languageSubject.next(selectedLanguage);
      this.updateDocumentLang(selectedLanguage.code);
    } else {
      console.error(`Language with code "${language}" not found.`);
    }
  }

  // Keep the document's lang attribute in sync with the selected language so
  // assistive technologies announce content in the correct language
  // (WCAG 3.1.2 Language of Page). index.html ships with lang="en"; without
  // this the attribute would stay "en" after switching to es/it.
  private updateDocumentLang(code: string): void {
    if (typeof document !== 'undefined' && document.documentElement) {
      document.documentElement.lang = code;
    }
  }
}
